import AdminClient from '../client/AdminClient';

class NotesService {

    static async create(session, note) {
        return AdminClient.post(`/v1/admin/admin_notes/`, session, this.parsedNote({...note}));
    }

    static async update(noteId, session, note) {
        return AdminClient.put(`/v1/admin/admin_notes/${noteId}`, session, this.parsedNote({...note}));
    }


    static async delete(noteId, session) {
        return AdminClient.delete(`/v1/admin/admin_notes/${noteId}`, session);
    }

    static parsedNote(note) {
        return note;
    }
}
export default NotesService;